import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'WriteReviewPDP',
        path: () => path.join(__dirname, './WriteReview'),
        resolve: () => require.resolveWeak('./WriteReview'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "WriteReviewPDP" */ './WriteReview')]).then(
                (proms) => proms[0]
            ),
    })
);
